// extracted by mini-css-extract-plugin
export default {"Primary":"TableCell_Primary__JEWOF","LightCheckbox":"TableCell_LightCheckbox__KJtlQ","LightText":"TableCell_LightText__ip9n2"};